import TransfersPage from "components/pages/TransfersPage";

/**
 * @name CaptureTransfersTransferPage
 * @returns {React.Component}
 * @description The capture component for the transfers page for the transfers group.
 * This capture is used in the following capture groups:
 * "Transfers" (abi22), "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersTransferPage(props) {
    return <TransfersPage />
}